/*
 * @Author: leehu
 * @Date: 2017-09-01 16:23:55
 * @Last Modified by: zhujian
 * @Last Modified time: 2019-09-23 17:20:39
 */
import React from 'react';
import _ from 'underscore';
import moment from 'moment';
import { Spin, Select } from 'antd';
import $ from 'jquery';
import AxiosTS from '../../core/axios';
import './StudentSelect.less';
class StudentSearchSelect extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      close: true,
      dataSource: [],
      query: _.extend({
        month: null,
        current: 1,
        size: 10,
        statusList: ["NORMAL"],
        nameLike: '',
        phoneLike:'',
        hidePhone: true,
        filterByPermission:true,
      }, props.query),
      dataSet: [],
      isAll: false,
      visible: false,
      loading: false,
    };
    this.reset = () => {
      this.handleQueryReset();
    }
  }

  componentDidMount() {
    this.fetchServerData();
  }

  handleQuery = (value) => {
    let name = value;
    clearTimeout(this.timer);
    this.timer = setTimeout(() => {
      this.state.query.current = 1;
      if (!!name && name.indexOf('$$') !== -1) {
        name = name.split('$$')[0];
      }
      this.state.query.nameLike = name;
      if (`${name}`.match(/^\d{3,}/)) {
        this.state.query.phoneLike = name;
      }
      this.setState({}, () => {
        this.fetchServerData();
      })
    }, 300);
  }

  handleQueryReset = () => {
    this.setState({
      query: _.extend({
        month: null,
        current: 1,
        size: 10,
        statusList: ["NORMAL"],
        hidePhone: true,
        filterByPermission:true,
        nameLike: '',
        phoneLike:'',
      }, this.props.query)
    }, () => {
      this.fetchServerData();
    });
  }

  fetchServerData(current = 1) {
    this.setState({ loading: true });
    this.state.query.current = current;
    const param = this.state.query;
    if (param.month) {
      const diff = param.month - moment().get('month') - 1;
      param.birthdayMonth = moment().add(diff, 'month').startOf('month').valueOf();
    }
    AxiosTS.Business(this.props.url || 'public/student/getStuDigestListCheckPermission', param).then((res) => {
      const data = res.result.records;
      if (param.current == 1) {
        this.setState({ dataSet: this.props.filter ? this.props.filter(data) : data, isAll: res.result.hasNext, });
      } else {
        let dataSet = this.state.dataSet.concat(this.props.filter ? this.props.filter(data) : data);
        this.setState({
          dataSet,
          isAll: res.result.hasNext,
          loading: false
        })
      }
    })
  }

  handleStudentSelect = (studentId) => {
    console.log(studentId,'studentId')
    if (studentId) {
      const students = _.filter(this.state.dataSet, (item) => {
        return item.id == studentId;
      });
      let obj = students[0];
      obj.studentId = obj.id;
      this.props.onSelect(obj)
    } else {
      this.props.clear();
    }
    this.handleQuery();
  }

  hasmore = (dom) => {
    clearTimeout(this.scroll)
    let height = $(dom.currentTarget).find('ul li').last().position().top
    this.scroll = setTimeout(() => {
      if (height < 500 && this.state.isAll) {
        this.fetchServerData(this.state.query.current + 1);
      }
    }, 300)
  }

  render() {
    return (
      <div
        className={this.state.visible ? 'common-select staticSelect common-select-active' : 'common-select staticSelect'}
        style={this.props.style}
      >
        {
          !!this.props.label && <div className='label'> {this.props.label}:</div>
        }
        <Select
          ref='student'
          mode={this.props.multiple ? 'muttiple' : undefined}
          showSearch
          allowClear
          removeIcon={<span className="icon iconfont" style={{color: 'red'}}>&#xe6f0;</span>}
          onChange={(student) => this.handleStudentSelect(student)}
          onSearch={this.handleQuery}
          onPopupScroll={(dom) => {
            this.hasmore(dom);
          }}
          placeholder={this.props.placeholder}
          value={this.props.defaultValue || undefined}
          filterOption={(input, option) => option}
        >
          {
            _.map(this.state.dataSet, (item) => {
              return (
                <Select.Option
                  key={item.id}
                  value={item.id}
                  style={{ whiteSpace: 'nowrap', display: 'flex', alignItems: 'center' }}
                  title={item.studentName}
                >
                  {item.studentName}
                </Select.Option>
              );
            })
          }
          {this.state.isAll &&
            <Select.Option disabled style={{ textAlign: 'center' }} value="spin">
              <Spin size="small" />
            </Select.Option>
          }
        </Select>
      </div>
    );
  }
}

StudentSearchSelect.propTypes = {};

StudentSearchSelect.defaultProps = {
  onSelect: () => { },
  multiple: false,
  showBirthdayFilter: false,
  query: {},
  filter: null, // 过滤器
  classId: null
};

export default StudentSearchSelect;